<mat-chip-option
  (selectionChange)="selectAll($event)"
  [selectable]="hasSelected()"
  [selected]="!hasSelected()"
  color="accent"
  role="listitem"
>
  {{ allLabel() }} <span>({{ totalCount() }})</span>
</mat-chip-option>

<ui-filter-chips
  (selectedChange)="selected.set($event)"
  [filterChips]="filterChips()"
  [selected]="selectedChips()"
></ui-filter-chips>
